module.exports = __webpack_public_path__ + "img/20181213_231258.34388261.jpg";